<template>
  <div class="checkout-header">
    <div class="checkout-header-inner">
      <OutputLogo />
      <CheckoutHeaderStep />
      <CheckoutHeaderControls :show-close="modal" />
    </div>
    <CheckoutHeaderProgressBar :progress="progress" />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useScreenStore } from '@/store/ScreenStore'
import CheckoutHeaderStep from '@/components/shared/header/CheckoutHeaderStep.vue'
import CheckoutHeaderControls from '@/components/shared/header/CheckoutHeaderControls.vue'
import CheckoutHeaderProgressBar from '@/components/shared/header/CheckoutHeaderProgressBar.vue'
import OutputLogo from '@/components/icons/OutputLogo.vue'

const screenStore = useScreenStore()
const { progress } = storeToRefs(screenStore)

defineProps({
  modal: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss" scoped>
.checkout-header {
  background-color: var(--color-bg-secondary);
  font-family: $font-family-pilat-bold;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  color: var(--color-text-primary);
  position: relative;

  &-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 80px;
    padding: 0 $spacer-4;

    svg {
      height: 70px;
      width: auto;

      @include media-breakpoint(375px) {
        width: 141px;
      }
    }
  }
}
</style>
